<div class="card-4">
    <div style="padding: 25px">
      <ng-container *ngIf="entreprise !==null">
        <app-prospect-form [prospect]="prospect" [isReadOnly]="true"  [type]="3"   (onUpdateProspect)="updateProspect($event,-1)">
        </app-prospect-form>
      </ng-container>
    </div>
  </div>
